import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Routes sur lesquelles le scroll smooth est actif
const SMOOTH_ROUTES = ['/', '/a-propos'];

const SmoothScroll = ({ children }) => {
    const lenisRef = useRef(null);
    const rafRef = useRef(null);
    const { pathname } = useLocation();

    const isSmooth = SMOOTH_ROUTES.includes(pathname);

    useEffect(() => {
        if (!isSmooth) {
            // Sur les autres pages, s'assurer que le scroll natif est propre
            document.documentElement.style.scrollBehavior = '';
            return;
        }

        // Initialisation de Lenis
        const lenis = new Lenis({
            duration: 1.4,          // Durée de l'inertie (secondes)
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // Ease exponentielle smooth
            smoothWheel: true,      // Smooth sur molette
            touchMultiplier: 1.5,   // Sensibilité tactile
            infinite: false,
        });

        lenisRef.current = lenis;

        // Lier Lenis à GSAP ScrollTrigger
        lenis.on('scroll', ScrollTrigger.update);

        gsap.ticker.add((time) => {
            lenis.raf(time * 1000);
        });

        // Désactiver le lagSmoothing de GSAP pour éviter le double buffering
        gsap.ticker.lagSmoothing(0);

        return () => {
            lenis.destroy();
            lenisRef.current = null;
            gsap.ticker.remove((time) => lenis.raf(time * 1000));
        };
    }, [isSmooth, pathname]);

    return children;
};

export default SmoothScroll;
